"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateHealthBarVfxVfxStepArgs = void 0;
const uuid_1 = require("uuid");
const enums_1 = require("../../enums");
class UpdateHealthBarVfxVfxStepArgs {
    constructor(actorId, percent) {
        this.actorId = actorId;
        this.percent = percent;
        this.__typeName = "UpdateHealthBarVfx";
        this.id = (0, uuid_1.v4)();
    }
    static fromActor(container, actorId) {
        const current = container.getAttributeScore(actorId, enums_1.AttributeType.Health);
        const max = container.getMaxAttributeScore(actorId, enums_1.AttributeType.Health);
        return new UpdateHealthBarVfxVfxStepArgs(actorId, current / max);
    }
}
exports.UpdateHealthBarVfxVfxStepArgs = UpdateHealthBarVfxVfxStepArgs;
